/**
 * Custom-column cell for `number` columns. Click to edit, save on blur/Enter,
 * cancel on Escape. Empty / non-numeric input clears the value (stored as null).
 */
import { useInlineCellEdit } from '../../lib/useInlineCellEdit';
import { EM_DASH } from './constants';

interface NumberCustomCellProps {
  value: number | undefined;
  onChange: (next: number | null) => void;
}

export function NumberCustomCell({ value, onChange }: NumberCustomCellProps) {
  const { editing, inputProps, triggerProps } = useInlineCellEdit(
    value !== undefined ? String(value) : '',
    (draft) => {
      if (draft === '') {
        if (value !== undefined) onChange(null);
        return;
      }
      const parsed = Number(draft);
      if (Number.isFinite(parsed) && parsed !== value) onChange(parsed);
    },
  );

  if (editing) {
    return (
      <input
        {...inputProps}
        type="number"
        inputMode="decimal"
        className="w-full bg-transparent text-center text-sm font-normal tabular-nums outline-none focus-visible:ring-2 focus-visible:ring-ring"
      />
    );
  }

  return (
    <button
      {...triggerProps}
      className="w-full text-center text-sm font-normal tabular-nums text-muted-foreground transition-colors hover:text-foreground"
    >
      {value !== undefined ? value : <span className="text-muted-foreground">{EM_DASH}</span>}
    </button>
  );
}
